export const sanitizeErrorMessage = (error: any): string => {
  // If error is a string, return it directly
  if (typeof error === 'string') {
    return error;
  }

  // If error is an object with a message property
  if (error?.message) {
    // Remove any HTTP status codes from the message
    return error.message.replace(/\b\d{3}\b/g, '');
  }

  // If error is an object with a response property (Axios error)
  if (error?.response?.data?.message) {
    return error.response.data.message.replace(/\b\d{3}\b/g, '');
  }

  // Default fallback message
  return 'An unexpected error occurred';
}; 